{
  "schema_version": "1.0",
  "run_id": "run_20260712_130000_ist",
  "edition_key": "2026-07-12-1300-Asia-Kolkata",
  "created_at": "2026-07-12T07:31:00Z",
  "selected": [
    {
      "rank": 1,
      "story_id": "sha256:story-001",
      "scores": {
        "importance": 5,
        "freshness": 4,
        "source_confidence": 4,
        "novelty": 5,
        "national_relevance": 5,
        "diversity_penalty": 0
      },
      "estimated_seconds": 35,
      "angle": "State the cabinet approval and the ₹12,000 crore outlay with attribution to The Hindu.",
      "selection_reason": "Fresh, nationally relevant policy development with clear fiscal detail.",
      "follow_up_to": null
    },
    {
      "rank": 2,
      "story_id": "sha256:story-002",
      "scores": {
        "importance": 4,
        "freshness": 4,
        "source_confidence": 5,
        "novelty": 4,
        "national_relevance": 5,
        "diversity_penalty": 0
      },
      "estimated_seconds": 30,
      "angle": "Report the repo rate hold at 5.5% with MPC attribution.",
      "selection_reason": "Stable economic indicator with high source confidence from Indian Express.",
      "follow_up_to": null
    },
    {
      "rank": 3,
      "story_id": "sha256:story-003",
      "scores": {
        "importance": 3,
        "freshness": 5,
        "source_confidence": 4,
        "novelty": 4,
        "national_relevance": 4,
        "diversity_penalty": 0
      },
      "estimated_seconds": 25,
      "angle": "Announce monsoon arrival in Delhi, two days ahead of normal onset.",
      "selection_reason": "Fresh weather development with direct impact on Delhi listeners.",
      "follow_up_to": null
    }
  ],
  "excluded": [
    {
      "story_id": "sha256:story-004",
      "reason_code": "STALE",
      "reason": "Story published over 48 hours ago; no material update since previous edition."
    }
  ],
  "target_seconds": 120
}
